/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateUnitRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateUnitResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateUnit = (request: UpdateUnitRequest, options?: CashRequestOptions) => post<UpdateUnitRequest, UpdateUnitResponse>("/2.0/cash/update-unit", request, {...options, rejectOnError: true })